<styles-smart-table
  #smartTable
  [datasource]="organizations.items"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [showColumnHeaders]="showColumnHeaders"
>
  <ng-container matColumnDef="spaceName">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div class="container">
        <mat-icon class="color-icon"> corporate_fare </mat-icon>
        {{$any(element)?.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner">Owner</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="default">Name</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div class="headers">
          <div class="title ellipsis-text">{{$any(element).name }}</div>
          <div class="sub-title">
            <mat-icon class="color-icon"> corporate_fare </mat-icon>
            <div class="ellipsis-text">{{$any(element)?.organizationType?.name }}</div>
          </div>
        </div>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="status">Status</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip
        [workStatus]="$safeNavigationMigration($any(element)?.status)"
      ></framework-work-status-chip>
    </td>
  </ng-container>
</styles-smart-table>
